import api from 'api';

export const loadEvents = api('GET /api/integrations/postbacks/fields/events');

export const loadAffiliates = api(
  'GET /api/integrations/postbacks/fields/affiliates'
);

export const loadParameters = api(
  'GET /api/integrations/postbacks/fields/parameters'
);

export const loadTargets = api(
  'GET /api/integrations/postbacks/fields/targets'
);

export const loadPlatforms = api(
  'GET /api/integrations/postbacks/fields/platforms'
);

export const loadApplications = api(
  'GET /api/integrations/postbacks/fields/applications'
);

export const loadNetworks = api(
  'GET /api/integrations/postbacks/fields/networks'
);

export const loadClusters = api(
  'GET /api/integrations/postbacks/fields/clusters'
);

export const loadBusinessPartners = api(
  'GET /api/integrations/postbacks/fields/business-partners'
);
export const loadTraffics = api(
  'GET /api/integrations/postbacks/fields/traffics'
);
export const loadActivityTypes = api(
  'GET /api/integrations/postbacks/fields/activity-types'
);
export const loadRegistrationCountries = api(
  'GET /api/integrations/postbacks/fields/registration-countries'
);

export const loadEventsCountries = api(
  'GET /api/integrations/postbacks/fields/events-countries'
);
